import type {
  Accessory,
  BasketAccessory,
} from '@/features/basket/types/accessory';
import type { Basket } from '@/features/basket/types/basket';
import type { Product } from '@/features/basket/types/product';
import type { BaseItem, ProductItem } from '@/libs/ga4';
import { ProductType } from '@/libs/ga4';

const mapProducts = (
  data: Basket,
  type: ProductType = ProductType.CART_ITEM,
  quantity?: number,
  coupon?: string,
): ProductItem[] => {
  const products = data.products.map((item, index) =>
    productMapper(item, index, type, quantity, coupon),
  );
  const accessories = (data.accessories ?? []).map(accessoryMapper);
  const items = [...products, ...accessories];

  return items as ProductItem[];
};

export const mapper = (
  product: Product | Accessory,
  index: number,
  type: ProductType = ProductType.CART_ITEM,
  quantity: number = 1,
  coupon?: string,
) => {
  if ('title' in product) {
    const accessory = { ...product, quantity };

    return accessoryMapper(accessory);
  } else {
    return productMapper(product as Product, index, type, quantity, coupon);
  }
};

export const productMapper = (
  {
    name,
    externalId,
    price,
    quantity: quantityProduct,
    itemCategory2,
    itemCategory,
    itemCategory3,
    item_brand,
  }: Product,
  index: number,
  type: ProductType = ProductType.CART_ITEM,
  quantity?: number,
  coupon?: string,
): ProductItem => {
  const baseItem: BaseItem = {
    item_name: name,
    item_id: `${externalId}`,
    item_brand,
    itemCategory,
    itemCategory2,
    itemCategory3,
    quantity: quantity ?? quantityProduct,
    price: `${price}`,
  };

  if (type === ProductType.PRODUCT_ITEM) {
    return {
      ...baseItem,
      quantity: 1,
      item_variant: '',
      item_list_name: 'cart',
      index: index + 1,
    };
  } else if (type === ProductType.PURCHASE_ITEM) {
    return { ...baseItem, item_coupon: coupon } as ProductItem;
  } else {
    return baseItem as ProductItem;
  }
};

const accessoryMapper = ({ price, quantity, title, id }: BasketAccessory) => ({
  item_name: title ?? '',
  item_id: `${id}`,
  item_brand: '',
  itemCategory: 'Accessory',
  itemCategory2: '',
  itemCategory3: '',
  quantity,
  price,
});

export default mapProducts;
